var render, staticRenderFns
import script from "./ScoutingReportDetailProvider.vue?vue&type=script&lang=ts&"
export * from "./ScoutingReportDetailProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports